import NiceModal, { useModal } from '@ebay/nice-modal-react'
import { useState } from 'react'
import { ArrowPathIcon } from '@heroicons/react/24/outline'

import ModalContainer from 'components/ModalContainer'
import { Button, Card, Input } from 'components/gsys-ui'
import { useResetInvoice } from 'util/mutations'
import { successToast } from 'util/helpers'

const ResetInvoiceModal = NiceModal.create(() => {
    const modal = useModal()
    const [invoiceNumber, setInvoiceNumber] = useState('')
    const [isLoading, setIsLoading] = useState(false)
    const resetMutation = useResetInvoice()

    const handleReset = async () => {
        if (!invoiceNumber.trim()) {
            return
        }

        setIsLoading(true)
        try {
            await resetMutation.mutateAsync(invoiceNumber.trim())
            successToast(`Invoice ${invoiceNumber} has been reset successfully.`)
            modal.remove()
        } catch (error) {
            console.error('Error resetting invoice:', error)
        } finally {
            setIsLoading(false)
        }
    }

    const handleKeyPress = (e) => {
        if (e.key === 'Enter') {
            handleReset()
        }
    }

    return (
        <ModalContainer>
            <Card className="!w-[400px]">
                <Card.Title Icon={ArrowPathIcon}>
                    <div>Reset Invoice</div>
                    <Button onClick={modal.remove}>Close</Button>
                </Card.Title>
                <Card.Body>
                    <div className="space-y-4">
                        <div>
                            <label className="block text-sm font-medium text-gray-700 mb-2">
                                Invoice Number
                            </label>
                            <Input
                                placeholder="Enter invoice number..."
                                value={invoiceNumber}
                                onChange={(e) => setInvoiceNumber(e.target.value)}
                                onKeyPress={handleKeyPress}
                                autoFocus
                            />
                        </div>
                        <div className="flex justify-end space-x-2">
                            <Button variant="secondary" onClick={modal.remove}>
                                Cancel
                            </Button>
                            <Button
                                onClick={handleReset}
                                disabled={!invoiceNumber.trim() || isLoading}
                                loading={isLoading}
                            >
                                Reset Invoice
                            </Button>
                        </div>
                    </div>
                </Card.Body>
            </Card>
        </ModalContainer>
    )
})

export default ResetInvoiceModal
